import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/content-hub/theme/constants";
import { MIN_DESKTOP_WIDTH } from "@/utils/constants";

export const BlockBackgroundColorWrapper = styled.div`
  background-color: ${({ theme }) =>
    theme.colors[ColorLabels["NEUTRAL-PRIMARY"]]};
`;

export const BlockPaddingWrapper = styled.div`
  padding: ${rem(80)} ${rem(24)};
`;

export const BlockMaxWidthWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${({ maxWidth }) => maxWidth || MIN_DESKTOP_WIDTH};
  margin: auto;
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
  `}
`;
